/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const ElementRichTextIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 16, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="ElementRichTextIcon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3 2C2.44772 2 2 2.44772 2 3V6C2 6.55228 2.44772 7 3 7H6C6.55228 7 7 6.55228 7 6V3C7 2.44772 6.55228 2 6 2H3ZM3 3H6V6H3V3Z"
              fill="currentColor"
            />
            <path d="M9 7H14V6H9V7Z" fill="currentColor" />
            <path d="M2 10H14V9H2V10Z" fill="currentColor" />
            <path d="M8 13H2V12H8V13Z" fill="currentColor" />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

ElementRichTextIcon.tags = [
  'rich',
  'rich text',
  'rtb',
  'rte',
  'text',
  'editor',
  'layout',
  'document',
  'content',
];

ElementRichTextIcon.category = 'Navigator';

ElementRichTextIcon.iconSize = 16;
